// extracted by mini-css-extract-plugin
var _1 = "NotFoundView__NotFoundView___t7c55";
var _2 = "NotFoundView__content___oveXW";
var _3 = "NotFoundView__hr___K1r5F";
var _4 = "NotFoundView__link___MidAM";
var _5 = "NotFoundView__wiggle___fm5O8";
export { _1 as "NotFoundView", _2 as "content", _3 as "hr", _4 as "link", _5 as "wiggle" }
